import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiCustom from "../../utils/ApiCustom";

export const getPublicVideo = createAsyncThunk(
  "youtube/getPublicVideo",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCustom.get("/get-media-video-public");
      return response.data.data.images;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Lỗi khi gọi API");
    }
  },
);

const YoutubePostsSlice = createSlice({
  name: "youtube",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {
    addItem: (state, action) => {
      state.items.push(action.payload);
    },
    removeItem: (state, action) => {
      state.items = state.items.filter((item) => item.id !== action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPublicVideo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPublicVideo.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(getPublicVideo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Lỗi không xác định";
      });
  },
});

export const { addItem, removeItem } = YoutubePostsSlice.actions;
export default YoutubePostsSlice.reducer;
